

import { Smartphone } from 'lucide-react';
import type { Product } from './types';
import { normalizeProductPricing } from './pricingNormalization';

export const androidAppSuite: Product = normalizeProductPricing({
  id: 'android-app-development-suite',
  title: 'Android App Development Suite',
  subtitle: 'Native Android applications with Google Play optimisation',
  description: 'Comprehensive Android app development platform featuring Kotlin development, Material Design implementation, Google Services integration, and Play Store optimisation with professional development support for UK businesses.',
  icon: Smartphone,
  image: 'https://images.unsplash.com/photo-1607252650355-f7fd0460ccdb?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
  category: 'Mobile Development',
  status: 'Available',
  features: [
    // Native Android Development
    'Native Kotlin & Java Development with UK Coding Standards',
    'Android SDK & Jetpack Libraries Implementation',
    'Material Design 3 Implementation for UK Market',
    'Android Architecture Components & MVVM Patterns',
    'Google Play Console Integration & UK App Store',
    'Play Store Optimisation & ASO for UK Audience',

    // User Interface & Experience
    'Jetpack Compose Modern UI',
    'Responsive Design for Tablets & Phones',
    'Custom Material Design Components',
    'Adaptive Icons & Splash Screens',
    'Gesture Navigation & Animations',
    'Accessibility & TalkBack Support',

    // Google Services Integration
    'Google Play Services Integration',
    'Firebase Authentication & Analytics',
    'Google Pay & In-App Billing',
    'Google Maps & Location Services',
    'Google Drive & Cloud Storage',
    'Google Assistant & Voice Actions',

    // Data Management
    'Room Database & SQLite',
    'Firebase Firestore Integration',
    'Real-Time Data Synchronization',
    'Offline Data Storage & Sync',
    'RESTful API & Retrofit Integration',
    'GraphQL Client Implementation',

    // Performance & Security
    'ProGuard Code Obfuscation & UK Data Protection',
    'Android App Bundle Optimisation for Fast Loading',
    'Network Security Configuration & GDPR Compliance',
    'Biometric Authentication Integration (UK Standards)',
    'Android Keystore Security & UK Banking Integration',
    'Performance Profiling & Optimisation for UK Networks',

    // Push Notifications & Communication
    'Firebase Cloud Messaging (FCM)',
    'Rich Media Notifications',
    'Background Services & WorkManager',
    'WebRTC Video & Voice Calling',
    'SMS & Phone Integration',
    'Email Client Implementation',

    // Media & Content
    'Camera2 API & CameraX',
    'Media Player & ExoPlayer',
    'Image Processing & Glide',
    'Document Scanner & ML Kit OCR',
    'PDF Viewer & Generator',
    'Augmented Reality with ARCore',

    // Analytics & Monitoring
    'Google Analytics & Firebase',
    'Custom Event Tracking',
    'Crash Reporting & Firebase Crashlytics',
    'A/B Testing with Firebase',
    'Performance Monitoring',
    'User Feedback & In-App Reviews',

    // Development Tools & Workflow
    'Android Studio Setup & Configuration',
    'Gradle Build System Optimisation',
    'Unit Testing & Espresso UI Testing',
    'CI/CD Pipeline Integration',
    'Code Quality & Static Analysis',
    'Documentation & Code Comments',

    // Device Features & Hardware
    'Bluetooth & NFC Integration',
    'Sensor Data & Hardware Access',
    'Wear OS Companion Apps',
    'Android Auto Integration',
    'IoT Device Communication',
    'Custom Hardware Integration',

    // Cloud & Backend Services
    'Google Cloud Platform Integration',
    'Firebase Backend Services',
    'Cloud Storage & CDN',
    'Server-Side API Development',
    'Database Management & Scaling',
    'Microservices Architecture',

    // Maintenance & Support
    '24/7 Technical Support & Monitoring',
    'Android Version Compatibility',
    'Google Play Policy Compliance',
    'Security Updates & Patches',
    'Feature Updates & Enhancements',
    'Client Training & Support Documentation',
  ],
  pricing: { setup: 25600, monthly: 425 },
  color: 'from-green-600 to-emerald-700',
  businessTypes: ['#AndroidFirst', '#GoogleEcosystem', '#MobileApp', '#PlayStore', '#MaterialDesign'],
});

